import axios from "axios";

const CERTIFICATE_TYPE_URL = "/api/certificate-type";

export default {
  data() {
    return {
      certificateTypeOptions: [],
      selectedCertificateTypes: [],
    };
  },
  methods: {
    getCertificateTypes() {
      axios.get(CERTIFICATE_TYPE_URL).then((response) => {
        if (response?.data) {
          this.certificateTypeOptions = response.data;
        }
      });
    },
    handleCertificateTypeTag(tag) {
      if (!tag) return;
      const tagName = tag.name ?? tag.id ?? String(tag);
      axios.post(CERTIFICATE_TYPE_URL, { name: tagName }).then((response) => {
        if (response?.data) {
          const newType = response.data;
          const tempIndex = this.certificateTypeOptions.findIndex(
            (item) => item.name === tagName && item.id === tagName
          );
          if (tempIndex !== -1) {
            this.certificateTypeOptions.splice(tempIndex, 1, newType);
          } else {
            this.certificateTypeOptions.push(newType);
          }
          const selectedTempIndex = this.selectedCertificateTypes.findIndex(
            (item) => item.name === tagName && item.id === tagName
          );
          if (selectedTempIndex !== -1) {
            this.selectedCertificateTypes.splice(selectedTempIndex, 1, newType);
          }
        }
      });
    },
  },
};
